<template>
  <div>
    <div
      class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2"
    >
      <div class="panel">
        <div class="panel-body">
          <Summary :data="summary" />
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <reasons-discard :series="seriesM" />
        </div>
      </div>
    </div>
    <div class="grid gap-y-6 gap-x-8 sm:grid-cols-1">
      <div class="panel">
        <div class="panel-body">
          <accepted-discarded :data="series_ok_discarded" :summary="summary" :height="500" />
        </div>
      </div>
      <div class="panel" v-if="crop_size_summary.length > 1">
        <div class="panel-body">
          <crop-sizes-dynamic
            :data="crop_size_summary"
            :organization_id="organization_id"
            :agro_exporter_process_id="agro_exporter_process_id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Summary from "@/components/views/organization/production/query_by_provider/charts/Summary.vue";
import ReasonsDiscard from "@/components/views/organization/production/query_by_provider/charts/ReasonsDiscard.vue";
import AcceptedDiscarded from "@/components/views/organization/production/query_by_provider/charts/AcceptedDiscarded.vue";
import CropSizesDynamic from "@/components/views/organization/production/query_by_provider/charts/CropSizesDynamic.vue";
export default {
  name: "AEProductionQueryProvidersShowProcessSummary",
  components: {
    Summary,
    ReasonsDiscard,
    AcceptedDiscarded,
    CropSizesDynamic
  },
  data() {
    return {
      seriesM: [40, 30, 15, 10, 5]
    };
  },
  props: {
    organization_id: { required: true },
    agro_exporter_process_id: { required: true },
    summary: { type: Object, required: true },
    providers_summary: { type: Array, required: true },
    crop_size_summary: { type: Array, required: true }
  },
  created() {},
  computed: {
    series_ok_discarded() {
      return {
        ok: this.providers_summary.map(p => p.ok_weight),
        discard: this.providers_summary.map(p => p.discarded_weight),
        categories: this.providers_summary.map(p => p.producer.fullname.split(', '))
      };
    }
  }
};
</script>
